import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20orange%20and%20teal%20abstract%20flowing%20gradient%20background%20with%20soft%20curves%2C%20modern%20clean%20tech%20style%2C%20minimalist%20geometric%20design%2C%20smooth%20fluid%20shapes%2C%20bright%20and%20inviting%20digital%20art%20wallpaper&width=1800&height=500&seq=cta-bg-aiye-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-accent-700/85"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          立即开始您的资源下载之旅
        </h2>
        <p className="text-white/80 text-sm mb-8 leading-relaxed">
          加入爱液下载，畅享2000+正版资源，安全、快速、免费的一站式下载体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-primary-700 font-semibold text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer text-center"
          >
            浏览全部资源
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/20 text-white font-semibold text-sm rounded-full hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer border border-white/30 text-center"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}